<template>
    <div >
        <el-row :gutter="5">
                <el-row :gutter="5">
                    <el-col :span="3">
                        <el-input v-model="sName" style="width:100%" placeholder="客户名称"></el-input>
                    </el-col>
                    <el-col :span="3">
                        <el-input v-model="sCode" style="width:100%" placeholder="客户简码"></el-input>
                    </el-col>
                    <el-col :span="3">
                        <el-input v-model="sDesc" style="width:100%" placeholder="客户全称"></el-input>
                    </el-col>
                    <el-col :span="2">
                        <el-button type="primary" style="width:100%" icon="el-icon-search" @click="handleRefresh">查询</el-button>
                    </el-col>
                    <el-col :span="2">
                        <el-button type="primary" style="width:100%" icon="el-icon-plus" @click="handleAdd">新增</el-button>
                    </el-col>
                </el-row>
            </el-col>
        </el-row>
    
        <el-table :data="Customers" 
            max-height="600" 
            v-loading="listLoading" 
            ref="singleTable" 
            border 
            header-cell-style="background-color: #f2f2f2;color:#707070;font-weight: normal; background-image: linear-gradient(to bottom,#f8f8f8 0,#ececec 100%);
    background-repeat: repeat-x;"
            @sort-change="changeTableSort" >
             <el-table-column label="删除" fixed width="60">
                <template slot-scope="scope">
                    <i class="el-icon-delete" @click="handleDelete(scope.$index, scope.row)"></i>
                </template>
            </el-table-column>
            <el-table-column label="编辑" fixed width="60">
                <template slot-scope="scope">
                    <i class="el-icon-edit" @click="handleEdit(scope.$index, scope.row)"></i>
                </template>
            </el-table-column>
            <el-table-column prop="Name" label="名称" sortable='custom' width="100"></el-table-column>
            <el-table-column prop="Code" label="简码" sortable='custom' width="100"></el-table-column>
            <el-table-column prop="Desc" label="全称" sortable='custom' width="180"></el-table-column>
            <el-table-column prop="Contact" label="联系人" width="80" align="right"></el-table-column>
            <el-table-column prop="Tel" label="客户电话" width="100"></el-table-column>
            <el-table-column prop="Address" label="地址" width="80"></el-table-column>
            <el-table-column prop="bEffect" label="有效" width="80"></el-table-column>
            <!-- <el-table-column label="操作">
                <template slot-scope="scope">
                        <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                        <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
                </template>
            </el-table-column> -->
        </el-table>
        <el-col  :span="24">
            <el-pagination small
                @current-change="handleCurrentChange"
                :current-page="pageIndex"
                :page-size="pageSize"
                layout="total, prev, pager, next"
                :total="recordtotal">
            </el-pagination>
        </el-col>

        <el-dialog :visible.sync="editFormVisible" width="600px" class="dialog"  >
            <el-form :model="editForm">
                <h1>详细信息</h1>
                <el-form-item label="客户名称" :label-width="formLabelWidth">
                    <el-input v-model="editForm.Name" auto-complete="off"></el-input>
                </el-form-item>
                 <el-form-item label="简码" :label-width="formLabelWidth">
                    <el-input v-model="editForm.Code" auto-complete="off"></el-input>
                </el-form-item>
                 <el-form-item label="全称" :label-width="formLabelWidth">
                    <el-input v-model="editForm.Desc" auto-complete="off"></el-input>
                </el-form-item>
                 <el-form-item label="联系人" :label-width="formLabelWidth">
                    <el-input v-model="editForm.Contact" auto-complete="off"></el-input>
                </el-form-item>
                 <el-form-item label="电话" :label-width="formLabelWidth">
                    <el-input v-model="editForm.Tel" auto-complete="off"></el-input>
                </el-form-item>
                 <el-form-item label="地址" :label-width="formLabelWidth">
                    <el-input v-model="editForm.Address" auto-complete="off" type="textarea" rows=3></el-input>
                </el-form-item>
                <el-form-item label="" :label-width="formLabelWidth">
                   <el-checkbox label="是否有效" v-model="editForm.bEffectType"></el-checkbox>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="handleCancel">取 消</el-button>
                <el-button type="primary" @click="handleUpdate">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import MaintainCustomerJs from "./MaintainCustomer.js";
    export default MaintainCustomerJs;
</script>

<style>
    .el-row {
        margin-bottom: 10px;
        &:last-child {
            margin-bottom: 0;
        }
    }

    h1{
            padding: 8px 0px 40px 10px;
            display: block;
            border-bottom: 1px solid #444;
    }

    .dialog{
        margin:0px;
    }
    
</style>





// WEBPACK FOOTER //
// src/components/MaintainCustomer/MaintainCustomer.vue